/* FELVO theme — interactions: scroll reveal, header, AJAX cart, sort,
   product gallery, and an AJAX cart-count refresher. Vanilla, no deps.
   (The hero's parallax/story motion lives inline in sections/hero.liquid.) */
(function () {
  "use strict";

  /* ---- Scroll reveal (IntersectionObserver) ------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target;
            var delay = el.getAttribute("data-reveal-delay") || 0;
            el.style.animationDelay = delay + "ms";
            el.classList.add("is-in");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.18 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Cart count refresh (after AJAX add-to-cart elsewhere) ------------- */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
      })
      .catch(function () {});
  }

  /* ---- AJAX add-to-cart for product forms with data-ajax-cart ------------ */
  function initAjaxCart() {
    document.querySelectorAll('form[action$="/cart/add"][data-ajax-cart]').forEach(function (form) {
      if (form.__felvoAjax) return;
      form.__felvoAjax = true;
      form.addEventListener("submit", function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var orig = btn ? btn.innerHTML : "";
        if (btn) btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(serialize(form)),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            refreshCartCount();
            if (btn) {
              btn.innerHTML = btn.getAttribute("data-added-label") || "Added to cart ✓";
              setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1800);
            }
          })
          .catch(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  function serialize(form) {
    var data = new FormData(form);
    var obj = { quantity: 1, properties: {} };
    data.forEach(function (v, k) {
      if (k === "id") obj.id = v;
      else if (k === "quantity") obj.quantity = parseInt(v, 10) || 1;
      else if (k.indexOf("properties[") === 0) {
        obj.properties[k.slice(11, -1)] = v;
      }
    });
    return obj;
  }

  /* ---- Header: frosted glass on scroll + mobile menu --------------------- */
  function initHeader() {
    var header = document.querySelector("[data-header]");
    if (header) {
      var onScroll = function () {
        header.classList.toggle("is-scrolled", window.scrollY > 24);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }
    var toggle = document.querySelector("[data-menu-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (toggle && menu) {
      var closeTimer = null;
      toggle.addEventListener("click", function () {
        var open = menu.hasAttribute("hidden");
        if (open) {
          // un-hide first, then flip [data-open] a frame later so the slide+fade transition runs
          clearTimeout(closeTimer);
          menu.removeAttribute("hidden");
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { menu.setAttribute("data-open", ""); });
          });
        } else {
          menu.removeAttribute("data-open");
          closeTimer = setTimeout(function () { menu.setAttribute("hidden", ""); }, 200);
        }
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
  }

  /* ---- Collection sorting: navigate to ?sort_by=<value> ------------------ */
  function initSort() {
    document.querySelectorAll("[data-sort-select]").forEach(function (sel) {
      if (sel.__felvoSort) return;
      sel.__felvoSort = true;
      sel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });
  }

  /* ---- Product gallery: scroll-snap carousel (RTL-safe, CSP-friendly) ----
     One track of w-full slides; arrows/thumbs/dots scroll to a slide via a
     getBoundingClientRect delta (sign-correct in both LTR and RTL), and a
     rAF-throttled scroll listener derives the active index for dots/thumbs.

     The reel is variant-scoped: `all*` hold every slide/thumb/dot the section
     rendered, while `slides`/`thumbs`/`dots` are the currently shown subset.
     applyFilter() rebuilds that subset for a variant (its own images first,
     then the shared ones) and reorders the DOM so index order stays visual
     order — which keeps every measurement below unchanged. */
  function initGallery() {
    var track = document.querySelector("[data-gallery-track]");
    if (!track || track.__felvoGallery) return;
    track.__felvoGallery = true;
    var allSlides = Array.prototype.slice.call(track.querySelectorAll("[data-gallery-slide]"));
    if (!allSlides.length) return;
    var root = track.closest("[data-gallery]") || document;
    var allThumbs = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-thumb]"));
    var allDots = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-dot]"));
    var thumbWrap = root.querySelector("[data-gallery-thumbs]");
    var dotWrap = root.querySelector("[data-gallery-dots]");
    var prev = root.querySelector("[data-gallery-prev]");
    var next = root.querySelector("[data-gallery-next]");
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var behavior = reduced ? "auto" : "smooth";
    var isRTL = getComputedStyle(track).direction === "rtl";
    var current = -1;
    var slides = allSlides.slice();
    var thumbs = allThumbs.slice();
    var dots = allDots.slice();

    function setActive(i) {
      if (i === current) return;
      current = i;
      dots.forEach(function (d, k) {
        if (k === i) { d.classList.add("bg-gold-300"); d.classList.remove("bg-cream/25"); }
        else { d.classList.add("bg-cream/25"); d.classList.remove("bg-gold-300"); }
      });
      thumbs.forEach(function (tb, k) {
        if (k === i) {
          tb.classList.add("ring-2", "ring-gold-300");
          tb.classList.remove("ring-1", "ring-white/10");
          if (tb.scrollIntoView) tb.scrollIntoView({ block: "nearest", inline: "nearest", behavior: behavior });
        } else {
          tb.classList.add("ring-1", "ring-white/10");
          tb.classList.remove("ring-2", "ring-gold-300");
        }
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i, bhv) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      var delta = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left: track.scrollLeft + delta, behavior: bhv || behavior });
      setActive(i);
    }

    /* Show only the given variant's images plus the unclaimed (shared) ones,
       the variant's own first. Called on every variant change; jumping is
       instant on purpose — the shopper asked for this view, so animating a
       scroll to it just reads as the page wandering off on its own. */
    function applyFilter(variantId) {
      var owned = [];
      var shared = [];
      allSlides.forEach(function (s, k) {
        var ids = s.getAttribute("data-variant-ids") || "-";
        if (variantId && ids.indexOf("," + variantId + ",") !== -1) owned.push(k);
        else if (ids === "-") shared.push(k);
      });
      var order = owned.concat(shared);
      if (!order.length) order = allSlides.map(function (_, k) { return k; });

      slides = [];
      thumbs = [];
      dots = [];
      allSlides.forEach(function (s) { s.hidden = true; });
      allThumbs.forEach(function (t) { t.hidden = true; });
      allDots.forEach(function (d) { d.hidden = true; });
      order.forEach(function (k) {
        allSlides[k].hidden = false;
        track.appendChild(allSlides[k]);
        slides.push(allSlides[k]);
        if (allThumbs[k] && thumbWrap) {
          allThumbs[k].hidden = false;
          thumbWrap.appendChild(allThumbs[k]);
          thumbs.push(allThumbs[k]);
        }
        if (allDots[k] && dotWrap) {
          allDots[k].hidden = false;
          dotWrap.appendChild(allDots[k]);
          dots.push(allDots[k]);
        }
      });

      var single = slides.length < 2;
      if (prev) prev.hidden = single;
      if (next) next.hidden = single;
      if (dotWrap) dotWrap.hidden = single;
      if (thumbWrap) thumbWrap.hidden = single;
      current = -1;
      goTo(0, "auto");
    }

    var raf = null;
    track.addEventListener(
      "scroll",
      function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          var i = Math.round(Math.abs(track.scrollLeft) / w);
          setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      },
      { passive: true }
    );

    if (prev) prev.addEventListener("click", function () { goTo(current - 1); });
    if (next) next.addEventListener("click", function () { goTo(current + 1); });
    /* Bind against the live subset, not the render-time index — filtering
       reorders and hides these, so a captured index would go stale. */
    allThumbs.forEach(function (tb) { tb.addEventListener("click", function () { goTo(thumbs.indexOf(tb)); }); });
    allDots.forEach(function (d) { d.addEventListener("click", function () { goTo(dots.indexOf(d)); }); });

    track.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var forward = (e.key === "ArrowRight") !== isRTL;
      goTo(current + (forward ? 1 : -1));
    });

    track.__felvoGoTo = goTo;
    track.__felvoFilter = applyFilter;
    setActive(0);
  }

  /* ---- Variant select: live-update price + scope gallery on change -------
     The buy box renders the default variant server-side; this reflects the
     chosen variant's price/compare-at and narrows the gallery to that
     variant's own images plus the shared lifestyle shots. */
  function initVariantSelect() {
    var sel = document.querySelector('select[name="id"]');
    if (!sel || sel.__felvoVariant) return;
    sel.__felvoVariant = true;
    var priceEl = document.querySelector("[data-price-display]");
    var compareEl = document.querySelector("[data-compare-display]");
    var track = document.querySelector("[data-gallery-track]");
    function update() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare) { compareEl.textContent = opt.dataset.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (track && track.__felvoFilter) track.__felvoFilter(opt.value);
    }
    sel.addEventListener("change", update);
    update();
  }

  /* ---- Money formatting (Shopify money_format placeholders) -------------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = parseInt(cents.replace(".", ""), 10);
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ","; decimal = decimal || ".";
      if (isNaN(number) || number == null) return "0";
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var m = (format || "{{amount}}").match(placeholder);
    var key = m ? m[1] : "amount";
    var value;
    if (key === "amount_no_decimals") value = withDelimiters(cents, 0);
    else if (key === "amount_with_comma_separator") value = withDelimiters(cents, 2, ".", ",");
    else if (key === "amount_no_decimals_with_comma_separator") value = withDelimiters(cents, 0, ".", ",");
    else value = withDelimiters(cents, 2);
    return (format || "{{amount}}").replace(placeholder, value);
  }

  /* ---- Cart page: live line-total + subtotal on qty change / remove ------
     Enhances the standard POST-and-reload cart form with /cart/change.js so
     prices update instantly; falls back to the Update button if JS fails. */
  function initCartPage() {
    var form = document.querySelector("[data-cart-form]");
    if (!form || form.__felvoCart) return;
    form.__felvoCart = true;
    var moneyFormat = form.getAttribute("data-money-format") || "{{amount}}";
    function render(cart) {
      if (!cart || cart.item_count === 0) { window.location.reload(); return; }
      var byKey = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; });
      form.querySelectorAll("[data-cart-line]").forEach(function (row) {
        var item = byKey[row.getAttribute("data-key")];
        if (!item) { row.remove(); return; }
        var lp = row.querySelector("[data-line-price]");
        if (lp) lp.textContent = formatMoney(item.final_line_price, moneyFormat);
        var qi = row.querySelector("[data-qty]");
        if (qi && document.activeElement !== qi) qi.value = item.quantity;
      });
      var sub = document.querySelector("[data-cart-subtotal]");
      if (sub) sub.textContent = formatMoney(cart.total_price, moneyFormat);
      refreshCartCount();
    }
    function change(key, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(render).catch(function () { window.location.reload(); });
    }
    form.querySelectorAll("[data-qty]").forEach(function (inp) {
      inp.addEventListener("change", function () {
        var q = parseInt(inp.value, 10);
        if (isNaN(q) || q < 0) q = 0;
        change(inp.getAttribute("data-key"), q);
      });
    });
    form.querySelectorAll("[data-remove]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        change(a.getAttribute("data-key"), 0);
      });
    });
  }

  /* ---- Welcome popup: first-order WELCOME10 email capture + reveal --------
     Native <dialog> (rendered globally in layout/theme.liquid). Opens on the
     first of {6s timer, 35% scroll, desktop exit-intent}; a 30-day localStorage
     cap suppresses dismissals and "converted" hides it forever. Email is a
     best-effort background POST to Shopify's customer form (never blocks the
     reveal), then the code panel is shown. GA4 events fire when gtag exists. */
  function initWelcomePopup() {
    var dialog = document.querySelector("[data-welcome-popup]");
    if (!dialog || dialog.__felvoWP) return;
    dialog.__felvoWP = true;

    var KEY = "felvo_welcome_v1";
    var SUPPRESS_MS = 30 * 24 * 60 * 60 * 1000;

    function read() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function write(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

    var state = read();
    if (state === "converted") return;
    if (state && state.indexOf("dismissed:") === 0) {
      var ts = parseInt(state.slice(10), 10);
      if (!isNaN(ts) && Date.now() - ts < SUPPRESS_MS) return;
    }

    var form = dialog.querySelector("[data-wp-form]");
    var emailInput = dialog.querySelector("[data-wp-email]");
    var consent = dialog.querySelector("[data-wp-consent]");
    var errorEl = dialog.querySelector("[data-wp-error]");
    var capturePanel = dialog.querySelector('[data-wp-panel="capture"]');
    var revealPanel = dialog.querySelector('[data-wp-panel="reveal"]');
    var copyBtn = dialog.querySelector("[data-wp-copy]");
    var codeText = dialog.querySelector("[data-wp-code-text]");
    var opened = false;

    function track(name) { if (window.gtag) { try { window.gtag("event", name); } catch (e) {} } }

    var timer = null;
    function teardown() {
      if (timer) clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onExit);
    }
    function open() {
      if (opened) return;
      opened = true;
      teardown();
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
      track("welcome_popup_view");
    }
    function close() {
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
    }
    function dismiss() { write("dismissed:" + Date.now()); close(); }

    function onScroll() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      if (h.scrollTop / max > 0.35) open();
    }
    function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) open(); }

    timer = setTimeout(open, 6000);
    window.addEventListener("scroll", onScroll, { passive: true });
    if (!("ontouchstart" in window)) document.addEventListener("mouseout", onExit);

    dialog.querySelectorAll("[data-wp-close]").forEach(function (b) {
      b.addEventListener("click", dismiss);
    });
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dismiss(); });
    dialog.addEventListener("cancel", function () { write("dismissed:" + Date.now()); });

    function reveal() {
      if (capturePanel) capturePanel.hidden = true;
      if (revealPanel) { revealPanel.hidden = false; revealPanel.classList.add("pp-in"); }
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = emailInput ? emailInput.value.trim() : "";
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          if (errorEl) errorEl.hidden = false;
          if (emailInput) emailInput.focus();
          return;
        }
        if (errorEl) errorEl.hidden = true;
        // Best-effort Shopify customer capture — marketing tag only if consented.
        try {
          var body = new URLSearchParams();
          body.append("form_type", "customer");
          body.append("utf8", "✓");
          body.append("contact[email]", email);
          body.append("contact[tags]", consent && consent.checked ? "newsletter, welcome-popup" : "welcome-popup");
          fetch("/contact", { method: "POST", body: body, headers: { Accept: "text/html" } }).catch(function () {});
        } catch (err) {}
        write("converted");
        track("welcome_signup");
        reveal();
      });
    }

    if (copyBtn && codeText) {
      copyBtn.addEventListener("click", function () {
        var code = codeText.textContent.trim();
        var orig = copyBtn.textContent;
        var done = function () {
          copyBtn.textContent = copyBtn.getAttribute("data-copied-label") || "Copied";
          setTimeout(function () { copyBtn.textContent = orig; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else { done(); }
      });
    }
  }

  function init() {
    initReveal();
    initHeader();
    initAjaxCart();
    initSort();
    initGallery();
    initVariantSelect();
    initCartPage();
    initWelcomePopup();
    refreshCartCount();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  // Re-init in the Shopify theme editor when sections reload
  document.addEventListener("shopify:section:load", init);
})();
